// Цветовая тема проекта

export default {

};
